import { Icon, ProgressBar, Spinner } from "@blueprintjs/core"
import React, { useMemo } from "react"
interface Props {
  onMouseLeave?:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined
  tripData?: any
}
const TripInfo = ({ tripData, onMouseLeave }: Props) => {
  const trip = tripData
  const vehicle = trip?.vehicle
  const bookings = trip?.bookings

  const aggregateQuantity = useMemo(() => {
    return bookings?.reduce(
      (acc, item) => {
        return {
          procuredQuantity: (acc.procuredQuantity += item.procuredQuantity),
          requiredQuantity: (acc.requiredQuantity += item.requiredQuantity),
        }
      },
      {
        procuredQuantity: 0,
        requiredQuantity: 0,
      }
    )
  }, [bookings])

  return (
    <>
      {tripData ? (
        <div className="vt-trip-info-window" onMouseLeave={onMouseLeave}>
          <div className="vehicle">
            <div className="grid grid-cols-12 gap-4 mb-2">
              <div className="col-span-1">
                <Icon icon="drive-time" />
              </div>
              <div className="col-span-9">
                <p className="vt-highlight">{vehicle?.registrationNumber}</p>
                <p>{vehicle?.vehicleType.name}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mb-2">
              <div className="col-span-1">
                <Icon icon="user" className="mr-2" />
              </div>
              <div className="col-span-9">
                <p className="vt-highlight">{trip?.aggregator?.fullName}</p>
                <p>{trip?.aggregator?.number}</p>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mb-2">
              <div className="col-span-1">
                <Icon icon="box" className="mr-2" />
              </div>
              <div className="col-span-9">
                <ProgressBar value={0.9} />
                <p className="vt-highlight text-base mt-1">
                  {aggregateQuantity?.procuredQuantity} /{" "}
                  {aggregateQuantity?.requiredQuantity}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </>
  )
}

export default TripInfo
